<script>
import setting from '@/setting'
import common from '@/common'
import $ from 'jquery'

export default {
    props: ['mode', 'currentState'],
    emits: ['change-mode', 'modal3d-off'],
    data() {
        return {
            setting,
            switchDisplay: 'display'
        }
    },
    methods: {
        changeMode: function (mode) {
            this.$emit('change-mode', mode)
        },
        modal3dOff: function (event) {
            this.$emit('modal3d-off')
        },
        switchDisplayMode: function (obj) {
            if (this.switchDisplay === 'display') {
                $('.switchDisplay').text("通常表示")
                this.switchDisplay = 'hide'
                common.LOG('INFO', '3D軌跡', '全画面表示切り替え', 'OFF')
            } else {
                $('.switchDisplay').text("全画面表示")
                this.switchDisplay = 'display'
                common.LOG('INFO', '3D軌跡', '全画面表示切り替え', 'ON')
            }
            $(".switchTarget").toggle()
        },
        prevPage: function () {
            if (this.$ls.get(this.setting.sessionKey.fromPT2)) {
                this.$router.push('./top')
            } else {
                this.$router.back()
            }
        },
        invalidPinch: function (e) {
            e.preventDefault()
        }
    }
}
</script>
